import { Divider, ListItem, ListItemText, Menu, MenuItem, Typography } from '@mui/material';
import { Fragment, memo, MouseEvent } from 'react';
import { useNavigate } from 'react-router-dom';

interface Props {
  onClick: (event: MouseEvent<HTMLElement>) => void;
  onClose: (event: MouseEvent) => void;
  submenuAnchor: Element | null;
  isSubmenuVisible: boolean;
}

const SubscriptionAireCitizenshipMenuComponent = ({
  onClick,
  onClose,
  isSubmenuVisible,
  submenuAnchor,
}: Props): React.ReactElement => {
  const navigate = useNavigate();

  return (
    <Fragment>
      <ListItem onClick={onClick}>
        <ListItemText primary="Iscrizione AIRE per acquisto cittadinanza Italiana" />
      </ListItem>
      <Menu
        id="subscription-aire-cittadinanza-menu"
        anchorEl={submenuAnchor}
        open={isSubmenuVisible}
        onClose={onClose}
        PaperProps={{
          style: {
            width: '30ch',
          },
        }}
      >
        <MenuItem
          key="nuova-famiglia-cittadinanza-menu-item"
          onClick={(event) => {
            onClose(event);
            navigate('/iscrizioni/aire-cittadinanza-nuova');
          }}
        >
          <Typography variant="inherit">Istituzione nuova famiglia</Typography>
        </MenuItem>
        <Divider key="nuova-famiglia-cittadinanza-divider" />
        <MenuItem
          key="aggregazione-menu-cittadinanza-item"
          onClick={(event) => {
            onClose(event);
            navigate('/iscrizioni/aire-cittadinanza-aggregazione');
          }}
        >
          <Typography variant="inherit">Aggregazione a famiglia</Typography>
        </MenuItem>
      </Menu>
    </Fragment>
  );
};

SubscriptionAireCitizenshipMenuComponent.displayName = 'Subscription Aire Citizenship Menu';

const SubscriptionAireCitizenshipMenu = memo(SubscriptionAireCitizenshipMenuComponent);

export default SubscriptionAireCitizenshipMenu;
